<template>

  <div id="body">
  	<app-header 
      :issessionset="sessionSet" 
      :user="user"
      :cart="cart"
      :items="items"
      @logout="logout">
    </app-header>

    <transition name="fade">
      <router-view name="sidebar" :issessionset="sessionSet"></router-view>
    </transition>

    <transition name="fade">
      <router-view 
        :issessionset="sessionSet"
        v-on:session="dadCheck($event)"
        :items="items"
        v-on:addtocart="add($event)"
        :user="user"
        :alreadyAdded="alreadyAdded"
        @removeitem="removeitem($event)"
        @endtransaction="endtransaction">
      </router-view>
    </transition>

    <app-footer 
      v-if="routeEnabled" 
      :issessionset="sessionSet">
    </app-footer>

    <app-copyright v-if="routeEnabled"></app-copyright>

  </div>
</template>

<script>
export default {
  data(){
  	return {

      //route
      routeEnabled: true,

      //user
      user: {
        id: '',
        name: '',
        email: ''
      },
      sessionSet: false,
      parentCheck: false,

      //cart
      cart: 0,
      items: [],
      itemcodes: [],
      alreadyAdded: false
  	}
  },
  methods: {

    logout: function(){
      var self = this;
      $.ajax({
        url: 'static/php/logout.php',
        success: function(data){
          if(data == true){
            self.user = {};
            self.sessionSet = false;
            self.$router.push({path: '/'});
            /*
            console.log(self.user);
            console.log(self.sessionSet);
            */
          }else{
            alert('something went wrong');
          }
        }
      });
    },

    endtransaction: function(){
      this.cart = 0;
      this.items = [];
      this.itemcodes = [];
      console.log('cart is empty');
    },

    dadCheck: function(bool){
      this.parentCheck = bool;
    },
    
    //hahahaha
    check: function(item){
      for(var i = 0; i < this.items.length; i++){
        if(this.items[i].code === item.code){
          return true;
          break;
        }
      }
      return false;
    },
    
    add: function(item){
      if(typeof item === 'object'){
          if(this.check(item)){
            this.alreadyAdded = true;
          }else{
            this.alreadyAdded = false;
            this.cart++;
            this.items.push(item);
            this.itemcodes.push(item.code);
            /*
            console.log(this.items);
            console.log(this.itemcodes);
            */
          }
      }
    },
    

    
    removeitem: function(itemcode){
        var items = this.items;
        for(var i = 0; i < this.items.length; i++){
          if(items[i].code === itemcode){
            this.cart--;
            items.splice(i, 1);
            this.itemcodes.splice(this.itemcodes.indexOf(itemcode), 1);
            break;
          }
        }
    }
    
  },
  created(){
      var self = this;

      //GET user session
      $.ajax({
        url: 'static/php/check_user_session.php',
        success: function(data){
          data = JSON.parse(data);
          if(data.constructor === Array){
            if(data.length < 1){
              //session not set
            }else{
              //session set
              self.sessionSet = true;
              self.user = data[0];
            }
          }
        }
      });

      //GET cart session
      $.ajax({
        url: 'static/php/check_cart_session.php',
        success: function(data){
          //alert(data);
          
          data = JSON.parse(data);
          if(data.constructor === Array){
            var count = data.length;
            if(count < 1){
              console.log('cart is empty');
            }else{
              self.cart = count;
              self.items = data;
              for(var i = 0; i < count; i++){
                self.itemcodes.push(data[i].code);
              }
              /*
              console.log(self.cart);
              console.log(self.items);
              console.log(self.itemcodes);
              */
            }
          }

          
        }
      });

  },
  mounted(){
    if(this.$route.name.match(/^(supplier|admin|user|404)/i) || this.$route.name.match(/Products/)){
      this.routeEnabled = false;
    }else{
      this.routeEnabled = true;
    }
    window.scrollTo(0,0);
  },
  watch: {
    '$route' (to, from){
      if(this.$route.name.match(/^(supplier|admin|user|404)/i) || this.$route.name.match(/Products/)){
        this.routeEnabled = false;
      }else{
        this.routeEnabled = true;
      }
      window.scrollTo(0,0);
    },
    
    //Check once
    parentCheck: function(newval){
      if(newval === true){
        var self = this;

        //GET user session
        $.ajax({
          url: 'static/php/check_user_session.php',
          success: function(data){
            data = JSON.parse(data);
            if(data.constructor === Array){
              if(data.length < 1){
                //session not set
              }else{
                //session set
                self.sessionSet = true;
                self.user = data[0];
              }
            }
          }
        });

        this.parentCheck = false;
      }
    },

    //Watch: cart, items, itemcodes

    itemcodes: function(newval){
      var self = this;
      $.ajax({
        url: 'static/php/check_cart_session.php',
        type: 'POST',
        data: {itemcodes: newval}
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// App.vue?d400f1c6